// panels/CreateCustomRolePanel.jsx
import React, { useState, useCallback } from "react";
import { Box, Typography, TextField, Button, Modal, Switch, styled, Paper, FormControlLabel, Grid, IconButton, TableHead, TableRow, TableCell, TableContainer, Table, TableBody, Checkbox } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import axios from "axios";
export default function CreateCustomRolePanel({ mode, customColors, setSnackbar, isLoading, setIsLoading }) {
    const [customRoleForm, setCustomRoleForm] = useState({ name: "", description: "" });
    const [customRoles, setCustomRoles] = useState([]);
   const [newRolePermissions, setNewRolePermissions] = useState({
  /* ================= FOLDER ================= */
  can_create_folder: false,
  can_read_folder: false,
  can_update_folder: false,
  can_delete_folder: false,
  can_import_folder: false,
  can_export_folder: false,

  /* ================= MCQ ================= */
  can_create_mcq: false,
  can_read_mcq: false,
  can_update_mcq: false,
  can_delete_mcq: false,

  /* ================= SUB ================= */
  can_create_sub: false,
  can_read_sub: false,
  can_update_sub: false,
  can_delete_sub: false,

  /* ================= FIB ================= */
  can_create_fib: false,
  can_read_fib: false,
  can_update_fib: false,
  can_delete_fib: false,

  /* ================= TF ================= */
  can_create_tf: false,
  can_read_tf: false,
  can_update_tf: false,
  can_delete_tf: false,

  /* ================= FLASHCARD ================= */
  can_start_flashcard: false,

  /* ================= QUIZ ================= */
  can_start_quiz: false,
  can_view_quiz_questions: false,
  can_submit_quiz_answers: false,
  can_view_quiz_result: false,
  can_view_quiz_attempt_result: false,
  can_view_quiz_history: false,

  /* ================= IMAGE (NEW – BACKEND MATCH) ================= */
  can_create_image: false,
  can_read_image: false,
  can_update_image: false,
  can_delete_image: false,

  /* ================= PROFILE (OLD – KEEP FOR SAFETY) ================= */
  can_create_profile: false,
  can_read_profile: false,
  can_update_profile: false,
  can_delete_profile: false,

  /* ================= STUDENT CLASS (NEW) ================= */
  can_create_student_class: false,
  can_read_student_class: false,
  can_update_student_class: false,
  can_delete_student_class: false,

  /* ================= REGISTRATION ================= */
  can_register_teacher: false,
  can_register_student: false,
  can_register_sub_admin: false,
  can_bulk_registration: false,

  /* ================= VIEW LISTS ================= */
  can_view_subadmin_list: false,
  can_view_teacher_list: false,
  can_view_student_list: false,

  /* ================= DELETE USERS ================= */
  can_delete_subadmin: false,
  can_delete_teacher: false,
  can_delete_student: false, // old (keep)
  can_delete_user: false,    // new (backend)

  /* ================= USER ROLE ================= */
  can_change_user_role: false,

  /* ================= USER DETAILS ================= */
  can_view_user_details: false,
  can_view_users_under_a_role: false,

  /* ================= CUSTOM ROLE ================= */
  can_register_custom: false,
  can_create_custom_role: false,
  can_delete_custom_role: false,
  can_change_custom_role: false, // old
  can_view_all_custom_roles: false,
  can_set_custom_role_permission: false,
  can_view_custom_role_permission: false,
  can_view_users_of_custom_roles: false,

  /* ================= PASSWORD ================= */
  can_reset_password: false,

  /* ================= USER STATUS ================= */
  can_enable_disable_users: false,
});

    const [permissionDialogOpen, setPermissionDialogOpen] = useState(false);
    const [newRoleName, setNewRoleName] = useState("");
const [permissionMode, setPermissionMode] = useState("custom"); 
// "all" | "custom"

    const apiUrl = process.env.REACT_APP_BASE_URL;
const CRUD_RESOURCES = [
  {
    label: "Folder",
    perms: {
      create: "can_create_folder",
      read: "can_read_folder",
      update: "can_update_folder",
      delete: "can_delete_folder",
    },
  },
  {
    label: "Mcq",
    perms: {
      create: "can_create_mcq",
      read: "can_read_mcq",
      update: "can_update_mcq",
      delete: "can_delete_mcq",
    },
  },
  {
    label: "Sub",
    perms: {
      create: "can_create_sub",
      read: "can_read_sub",
      update: "can_update_sub",
      delete: "can_delete_sub",
    },
  },
  {
    label: "Fib",
    perms: {
      create: "can_create_fib",
      read: "can_read_fib",
      update: "can_update_fib",
      delete: "can_delete_fib",
    },
  },
  {
    label: "Tf",
    perms: {
      create: "can_create_tf",
      read: "can_read_tf",
      update: "can_update_tf",
      delete: "can_delete_tf",
    },
  },
  {
    label: "Profile",
    perms: {
      create: "can_create_profile",
      read: "can_read_profile",      // Fixed: was null
      update: "can_update_profile",
      delete: "can_delete_profile",  // Fixed: was null
    },
  },
  {
    label: "Custom Role",
    perms: {
      create: "can_create_custom_role",
      read: "can_view_all_custom_roles",     // Fixed
      update: "can_change_custom_role",      // Fixed (or use can_set_custom_role_permission)
      delete: "can_delete_custom_role",
    },
  },
  {
    label: "User",
    perms: {
      create: "can_register_student",        // or can_register_teacher etc.
      read: "can_view_user_details",         // Fixed
      update: "can_change_user_role",        // Fixed
      delete: "can_delete_user",             // Fixed: was using old can_delete_student
    },
  },
  {
    label: "Image",
    perms: {
      create: "can_create_image",
      read: "can_read_image",
      update: "can_update_image",
      delete: "can_delete_image",
    },
  },
  {
    label: "Student Class",
    perms: {
      create: "can_create_student_class",
      read: "can_read_student_class",
      update: "can_update_student_class",
      delete: "can_delete_student_class",
    },
  },
];

    const handleCustomRoleFormChange = useCallback((key) => (event) => {
        setCustomRoleForm((prev) => ({
            ...prev,
            [key]: event.target.value,
        }));
    }, []); // Empty dependency array since it only uses the setter function

    const handleNewRolePermissionChange = (key) => (event) => {
        setNewRolePermissions((prev) => ({
            ...prev,
            [key]: event.target.checked,
        }));
    };

    const StyledPaper = styled(Paper)(({ theme, mode, customColors }) => ({
        padding: theme.spacing(3),
        marginTop: theme.spacing(2),
        backgroundColor:
            mode === "dark"
                ? "#2A2A3C"
                : mode === "custom"
                    ? customColors?.background || "#f5f5f5"
                    : "#f0f7ff",
        borderRadius: "8px",
        boxShadow:
            mode === "dark"
                ? "0 2px 8px rgba(0,0,0,0.6)"
                : "0 2px 8px rgba(0,0,0,0.15)",
    }));

    const handlePermissionDialogCancel = async () => {
        try {
            const token = sessionStorage.getItem("authToken");
            const falsePermissions = Object.keys(newRolePermissions).reduce((acc, key) => {
                acc[key] = false;
                return acc;
            }, {});
            await axios.post(`${apiUrl}/custom-roles/set-permissions/`,
                {
                    role_name: newRoleName,
                    permissions: falsePermissions,
                },
                { headers: { Authorization: `Bearer ${token}` } }
            );
            setSnackbar({
                open: true,
                message: `Permissions set to false for ${newRoleName}.`,
                severity: "success",
            });
        } catch (error) {
            console.error("Failed to set permissions to false:", error);
            setSnackbar({
                open: true,
                message: error.response?.data?.error || error.response?.data?.message || "Failed to set permissions to false. Please try again.",
                severity: "error",
            });
        }
        setPermissionDialogOpen(false);
        setNewRolePermissions(
            Object.keys(newRolePermissions).reduce((acc, key) => {
                acc[key] = false;
                return acc;
            }, {})
        );
        setNewRoleName("");
    };


    const handlePermissionDialogSave = async () => {
        try {
            const token = sessionStorage.getItem("authToken");
            await axios.post(`${apiUrl}/custom-roles/set-permissions/`,
                {
                    role_name: newRoleName,
                    permissions: newRolePermissions,
                },
                { headers: { Authorization: `Bearer ${token}` } }
            );
            setSnackbar({
                open: true,
                message: `Permissions set successfully for ${newRoleName}.`,
                severity: "success",
            });
            setPermissionDialogOpen(false);
            setNewRolePermissions(
                Object.keys(newRolePermissions).reduce((acc, key) => {
                    acc[key] = false;
                    return acc;
                }, {})
            );
            setNewRoleName("");
        } catch (error) {
            console.error("Failed to set permissions for new role:", error);
            setSnackbar({
                open: true,
                message: error.response?.data?.error || error.response?.data?.message || "Failed to set permissions. Please try again.",
                severity: "error",
            });
        }
    };

    const handleCreateCustomRole = async (event) => {
        event.preventDefault();
        if (customRoleForm.name.toLowerCase() === "admin") {
            setSnackbar({
                open: true,
                message: "You cannot create an admin role.",
                severity: "error",
            });
            return;
        }
        try {
            const token = sessionStorage.getItem("authToken");
            const response = await axios.post(`${apiUrl}/custom-roles/create/`,
                { role_name: customRoleForm.name },
                { headers: { Authorization: `Bearer ${token}` } }
            );
            const newRole = {
                id: response.data.id,
                name: response.data.name,
                permissions: response.data.permissions || {},
                created_by: response.data.created_by || sessionStorage.getItem("userEmail"),
            };
            setCustomRoles((prev) => [...prev, newRole]);
            setCustomRoleForm({ name: "", description: "" });
            setSnackbar({
                open: true,
                message: response.data.message || `Custom role ${customRoleForm.name} created successfully.`,
                severity: "success",
            });
            setNewRoleName(customRoleForm.name);
            setPermissionDialogOpen(true);
        } catch (error) {
            console.error("Failed to create custom role:", error);
            setSnackbar({
                open: true,
                message: error.response?.data?.error || error.response?.data?.message || "Failed to create custom role. Please try again.",
                severity: "error",
            });
        }
    };
const permissionCardSx = {
  p: 2.5,
  mb: 2,
  borderRadius: 3,
  background: "#dff1fb",
  border: "1px solid #b6def5",
  boxShadow: "0 6px 18px rgba(30,58,138,0.08)",
};

const permissionTitleSx = {
  fontWeight: 700,
  mb: 1,
  color: "#1e3a8a",
  fontSize: "0.95rem",
};
const setAllPermissions = (value) => {
    setNewRolePermissions(prev => {
        const updated = { ...prev };
        Object.keys(updated).forEach(key => {
            updated[key] = value;
        });
        return updated;
    });
};


    return (
        <>
            <StyledPaper
                sx={{
                    background: mode === "dark"
                        ? "linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)"
                        : mode === "custom"
                            ? `linear-gradient(135deg, ${customColors?.background || "#f5f5f5"} 0%, ${customColors?.primary || "#1e8bafff"}15 100%)`
                            : "linear-gradient(135deg, #ffffff 0%, #f0f7ff 100%)",
                    maxWidth: 520,
                    mx: "auto",
                    p: 4,
                    borderRadius: "16px",
                    boxShadow: mode === "dark"
                        ? "0 8px 32px rgba(0, 0, 0, 0.4)"
                        : "0 8px 32px rgba(30, 58, 138, 0.12)",
                    border: mode === "dark"
                        ? "1px solid rgba(255, 255, 255, 0.1)"
                        : "1px solid rgba(30, 139, 175, 0.1)",
                }}
            >
                <Box sx={{ mb: 3 }}>
                    <Typography
                        variant="h5"
                        sx={{
                            background: "linear-gradient(135deg, #1e3a8a 0%, #1e8bafff 100%)",
                            WebkitBackgroundClip: "text",
                            WebkitTextFillColor: "transparent",
                            backgroundClip: "text",
                            mb: 1,
                            fontWeight: 700,
                            letterSpacing: "-0.5px"
                        }}
                    >
                        Create Custom Role
                    </Typography>
                    <Typography
                        variant="body2"
                        sx={{
                            color: mode === "dark"
                                ? "rgba(255, 255, 255, 0.6)"
                                : mode === "custom"
                                    ? customColors?.text ? `${customColors.text}99` : "rgba(0, 0, 0, 0.6)"
                                    : "rgba(0, 0, 0, 0.6)",
                            fontSize: "0.875rem"
                        }}
                    >
                        Define a new role with custom permissions
                    </Typography>
                </Box>

                <Box
                    component="form"
                    onSubmit={handleCreateCustomRole}
                    sx={{ display: "flex", flexDirection: "column", gap: 3 }}
                >
                    <TextField
                        label="Role Name"
                        value={customRoleForm.name}
                        onChange={handleCustomRoleFormChange("name")}
                        required
                        fullWidth
                        placeholder="e.g., Senior Developer, Team Lead"
                        autoFocus
                        sx={{
                            "& .MuiOutlinedInput-root": {
                                backgroundColor: mode === "dark"
                                    ? "rgba(255, 255, 255, 0.05)"
                                    : mode === "custom"
                                        ? customColors?.inputBg || "#ffffff"
                                        : "#ffffff",
                                borderRadius: "12px",
                                transition: "all 0.3s ease",
                                "&:hover": {
                                    backgroundColor: mode === "dark"
                                        ? "rgba(255, 255, 255, 0.08)"
                                        : mode === "custom"
                                            ? customColors?.inputBg ? `${customColors.inputBg}dd` : "#f8fbff"
                                            : "#f8fbff",
                                },
                                "&.Mui-focused": {
                                    backgroundColor: mode === "dark"
                                        ? "rgba(255, 255, 255, 0.08)"
                                        : "#ffffff",
                                    boxShadow: mode === "dark"
                                        ? "0 0 0 3px rgba(30, 139, 175, 0.2)"
                                        : "0 0 0 3px rgba(30, 139, 175, 0.1)",
                                },
                                "& fieldset": {
                                    borderColor: mode === "dark"
                                        ? "rgba(255, 255, 255, 0.1)"
                                        : "rgba(30, 139, 175, 0.2)",
                                    borderWidth: "1.5px",
                                },
                                "&:hover fieldset": {
                                    borderColor: "rgba(30, 139, 175, 0.4)",
                                },
                                "&.Mui-focused fieldset": {
                                    borderColor: "#1e8bafff",
                                    borderWidth: "2px",
                                },
                            },
                            "& .MuiInputLabel-root": {
                                color: mode === "dark"
                                    ? "rgba(255, 255, 255, 0.7)"
                                    : mode === "custom"
                                        ? customColors?.text || "rgba(0, 0, 0, 0.7)"
                                        : "rgba(0, 0, 0, 0.7)",
                                fontWeight: 500,
                                "&.Mui-focused": {
                                    color: "#1e8bafff",
                                    fontWeight: 600,
                                },
                            },
                            "& .MuiInputBase-input": {
                                color: mode === "dark"
                                    ? "#ffffff"
                                    : mode === "custom"
                                        ? customColors?.text || "#111111"
                                        : "#111111",
                                fontSize: "1rem",
                                padding: "14px 16px",
                            },
                        }}
                    />

                    <Button
                        type="submit"
                        variant="contained"
                        sx={{
                            background: "linear-gradient(135deg, #1e3a8a 0%, #1e8bafff 100%)",
                            color: "white",
                            fontWeight: 600,
                            fontSize: "1rem",
                            textTransform: "none",
                            py: 1.5,
                            borderRadius: "12px",
                            boxShadow: "0 4px 14px rgba(30, 139, 175, 0.3)",
                            transition: "all 0.3s ease",
                            "&:hover": {
                                background: "linear-gradient(135deg, #1e3a8a 0%, #1a7a9a 100%)",
                                boxShadow: "0 6px 20px rgba(30, 139, 175, 0.4)",
                                transform: "translateY(-2px)",
                            },
                            "&:active": {
                                transform: "translateY(0px)",
                                boxShadow: "0 2px 8px rgba(30, 139, 175, 0.3)",
                            },
                        }}
                    >
                        Create Role
                    </Button>
                </Box>
            </StyledPaper>

            <Modal
                open={permissionDialogOpen}
                aria-labelledby="permission-dialog-title"
                aria-describedby="permission-dialog-description"
                sx={{
                    backdropFilter: "blur(4px)",
                }}
            >
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: { xs: "90%", sm: 650 },
                        maxHeight: "85vh",
                        display: "flex",
                        flexDirection: "column",
                        borderRadius: "20px",
                        boxShadow: mode === "dark"
                            ? "0 20px 60px rgba(0, 0, 0, 0.5)"
                            : "0 20px 60px rgba(30, 58, 138, 0.15)",
                        border: mode === "dark"
                            ? "1px solid rgba(255, 255, 255, 0.1)"
                            : "1px solid rgba(30, 139, 175, 0.1)",
                        background: mode === "dark"
                            ? "linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)"
                            : mode === "custom"
                                ? `linear-gradient(135deg, ${customColors?.background || "#f5f5f5"} 0%, ${customColors?.primary || "#1e8bafff"}15 100%)`
                                : "linear-gradient(135deg, #ffffff 0%, #f0f7ff 100%)",
                        overflow: "hidden",
                    }}
                >
                    {/* Sticky Header */}
                    <Box
                        sx={{
                            position: "sticky",
                            top: 0,
                            zIndex: 2,
                            background: mode === "dark"
                                ? "linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)"
                                : mode === "custom"
                                    ? `linear-gradient(135deg, ${customColors?.background || "#f5f5f5"} 0%, ${customColors?.primary || "#1e8bafff"}15 100%)`
                                    : "linear-gradient(135deg, #ffffff 0%, #f0f7ff 100%)",
                            p: 4,
                            pb: 2,
                            borderRadius: "20px 20px 0 0",
                            boxShadow: mode === "dark"
                                ? "0 4px 12px rgba(0, 0, 0, 0.3)"
                                : "0 4px 12px rgba(30, 139, 175, 0.1)",
                        }}
                    >
                        {/* Close Icon */}
                        <IconButton
                            onClick={handlePermissionDialogCancel}
                            sx={{
                                position: "absolute",
                                top: 16,
                                right: 16,
                                color: mode === "dark" ? "#ffffff" : "#1e3a8a",
                                backgroundColor: mode === "dark" ? "rgba(255, 255, 255, 0.1)" : "rgba(30, 139, 175, 0.1)",
                                "&:hover": {
                                    backgroundColor: mode === "dark" ? "rgba(255, 255, 255, 0.2)" : "rgba(30, 139, 175, 0.2)",
                                },
                            }}
                        >
                            <CloseIcon fontSize="small" />
                        </IconButton>

                        {/* Modal Heading */}
                        <Typography
                            id="permission-dialog-title"
                            variant="h5"
                            sx={{
                                background: "linear-gradient(135deg, #1e3a8a 0%, #1e8bafff 100%)",
                                WebkitBackgroundClip: "text",
                                WebkitTextFillColor: "transparent",
                                backgroundClip: "text",
                                mb: 1,
                                fontWeight: 700,
                                letterSpacing: "-0.5px",
                            }}
                        >
                            Set Permissions for {newRoleName.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()) || "New Role"}
                        </Typography>
                  <Box sx={{ mt: 2, mb: 2 }}>
    <Typography sx={{ fontWeight: 600, mb: 1, color: "#1e3a8a" }}>
        Permission Selection
    </Typography>

    <Box sx={{ display: "flex", gap: 3 }}>
        <FormControlLabel
            control={
                <input
                    type="radio"
                    checked={permissionMode === "all"}
                    onChange={() => {
                        setPermissionMode("all");
                        setAllPermissions(true);
                    }}
                />
            }
            label="Enable All"
        />

        <FormControlLabel
            control={
                <input
                    type="radio"
                    checked={permissionMode === "custom"}
                    onChange={() => {
                        setPermissionMode("custom");
                        setAllPermissions(false);
                    }}
                />
            }
            label="Custom Selection"
        />
    </Box>
</Box>

                    </Box>


                    {/* Scrollable Permissions Grid */}
                    <Box
                        sx={{
                            flex: 1,
                            overflowY: "auto",
                            p: 2,
                            // Scrollbar styling
                            "&::-webkit-scrollbar": {
                                width: "6px",
                            },
                            "&::-webkit-scrollbar-track": {
                                background: "transparent",
                            },
                            "&::-webkit-scrollbar-thumb": {
                                background: mode === "dark"
                                    ? "rgba(255, 255, 255, 0.3)"
                                    : "rgba(30, 139, 175, 0.3)",
                                borderRadius: "4px",
                            },
                        }}
                    >
                        
     {/* CRUD PERMISSIONS TABLE */}
<Paper
  sx={{
    mb: 3,
    borderRadius: 3,
    overflow: "hidden",
    border: "1px solid #c7e3f6",
    boxShadow: "0 8px 24px rgba(30,58,138,0.12)",
  }}
>
  {/* Table Title */}
  <Box
    sx={{
      background: "linear-gradient(90deg,#1e3a8a,#1e8bafff)",
      color: "#fff",
      px: 3,
      py: 2,
      fontWeight: 700,
      fontSize: "1.05rem",
      letterSpacing: "0.5px",
    }}
  >
    CRUD PERMISSIONS
  </Box>

  <TableContainer
    sx={{
      maxHeight: "420px",           // Adjust height as needed
      overflow: "auto",
      borderRadius: "0 0 12px 12px",
      "&::-webkit-scrollbar": {
        width: "8px",
      },
      "&::-webkit-scrollbar-track": {
        background: mode === "dark" ? "rgba(255,255,255,0.05)" : "#f1f5f9",
      },
      "&::-webkit-scrollbar-thumb": {
        background: mode === "dark" ? "rgba(255,255,255,0.3)" : "#94a3b8",
        borderRadius: "4px",
      },
      "&::-webkit-scrollbar-thumb:hover": {
        background: mode === "dark" ? "rgba(255,255,255,0.5)" : "#64748b",
      },
    }}
  >
    <Table size="small" sx={{ minWidth: "100%", tableLayout: "fixed" }}>
      <TableHead>
        <TableRow
          sx={{
            background: "linear-gradient(90deg, #2563eb, #3b82f6)",
            position: "sticky",
            top: 0,
            zIndex: 10,
            boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
          }}
        >
          {["RESOURCE", "CREATE", "READ", "UPDATE", "DELETE"].map((header, index) => (
            <TableCell
              key={header}
              align={index === 0 ? "left" : "center"}
              sx={{
                color: "#fff",
                fontWeight: 700,
                fontSize: "0.85rem",
                py: 2,
                px: 3,
                borderBottom: "2px solid rgba(255,255,255,0.3)",
                width: index === 0 ? "35%" : "16.25%",
                whiteSpace: "nowrap",
              }}
            >
              {header}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>

      <TableBody>
        {CRUD_RESOURCES.map((row, idx) => (
          <TableRow
            key={row.label}
            hover
            sx={{
              backgroundColor: idx % 2 === 0 ? "#f0f9ff" : "#e6f4ff",
              "&:hover": {
                backgroundColor: "#dbeafe",
              },
            }}
          >
            <TableCell
              sx={{
                fontWeight: 600,
                color: "#1e3a8a",
                fontSize: "0.9rem",
                py: 2,
                px: 3,
                borderBottom: "1px solid #e0f2fe",
              }}
            >
              {row.label}
            </TableCell>

            {["create", "read", "update", "delete"].map((action) => {
              const permKey = row.perms[action];
              return (
                <TableCell
                  key={action}
                  align="center"
                  sx={{
                    py: 2,
                    px: 2,
                    borderBottom: "1px solid #e0f2fe",
                  }}
                >
                  {permKey ? (
                    <Checkbox
                      checked={!!newRolePermissions[permKey]}
                      onChange={(e) =>
                        setNewRolePermissions((prev) => ({
                          ...prev,
                          [permKey]: e.target.checked,
                        }))
                      }
                      size="small"
                      sx={{
                        color: "#1e88e5",
                        "&.Mui-checked": {
                          color: "#2563eb",
                        },
                      }}
                    />
                  ) : (
                    <Typography variant="body2" color="text.secondary">–</Typography>
                  )}
                </TableCell>
              );
            })}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
</Paper>

{/* ================= OTHER PERMISSIONS ================= */}
<Typography
  variant="h6"
  sx={{ mb: 2, fontWeight: 700, color: "#1e3a8a" }}
>
  Other Permissions
</Typography>

{/* Flashcard */}
<Paper sx={permissionCardSx}>
  <Typography sx={permissionTitleSx}>Flashcard</Typography>
  <FormControlLabel
    sx={{ ml: 0 }}
    control={
      <input
        type="checkbox"
        checked={newRolePermissions.can_start_flashcard}
        onChange={(e) =>
          setNewRolePermissions(p => ({
            ...p,
            can_start_flashcard: e.target.checked,
          }))
        }
      />
    }
    label="Start"
  />
</Paper>

{/* Quiz */}
<Paper sx={permissionCardSx}>
  <Typography sx={permissionTitleSx}>Quiz</Typography>
  <FormControlLabel
    sx={{ ml: 0 }}
    control={
      <input
        type="checkbox"
        checked={newRolePermissions.can_start_quiz}
        onChange={(e) =>
          setNewRolePermissions(p => ({
            ...p,
            can_start_quiz: e.target.checked,
          }))
        }
      />
    }
    label="Start"
  />
</Paper>

{/* Quiz Questions */}
<Paper sx={permissionCardSx}>
  <Typography sx={permissionTitleSx}>Quiz Questions</Typography>
  <FormControlLabel
    sx={{ ml: 0 }}
    control={
      <input
        type="checkbox"
        checked={newRolePermissions.can_view_quiz_questions}
        onChange={(e) =>
          setNewRolePermissions(p => ({
            ...p,
            can_view_quiz_questions: e.target.checked,
          }))
        }
      />
    }
    label="View"
  />
</Paper>

{/* Quiz Answers */}
<Paper sx={permissionCardSx}>
  <Typography sx={permissionTitleSx}>Quiz Answers</Typography>
  <FormControlLabel
    sx={{ ml: 0 }}
    control={
      <input
        type="checkbox"
        checked={newRolePermissions.can_submit_quiz_answers}
        onChange={(e) =>
          setNewRolePermissions(p => ({
            ...p,
            can_submit_quiz_answers: e.target.checked,
          }))
        }
      />
    }
    label="Submit"
  />
</Paper>

{/* Quiz Result */}
<Paper sx={permissionCardSx}>
  <Typography sx={permissionTitleSx}>Quiz Result</Typography>
  <FormControlLabel
    sx={{ ml: 0 }}
    control={
      <input
        type="checkbox"
        checked={newRolePermissions.can_view_quiz_result}
        onChange={(e) =>
          setNewRolePermissions(p => ({
            ...p,
            can_view_quiz_result: e.target.checked,
          }))
        }
      />
    }
    label="View"
  />
</Paper>

{/* Quiz Attempt Result */}
<Paper sx={permissionCardSx}>
  <Typography sx={permissionTitleSx}>Quiz Attempt Result</Typography>
  <FormControlLabel
    sx={{ ml: 0 }}
    control={
      <input
        type="checkbox"
        checked={newRolePermissions.can_view_quiz_attempt_result}
        onChange={(e) =>
          setNewRolePermissions(p => ({
            ...p,
            can_view_quiz_attempt_result: e.target.checked,
          }))
        }
      />
    }
    label="View"
  />
</Paper>

{/* Quiz History */}
<Paper sx={permissionCardSx}>
  <Typography sx={permissionTitleSx}>Quiz History</Typography>
  <FormControlLabel
    sx={{ ml: 0 }}
    control={
      <input
        type="checkbox"
        checked={newRolePermissions.can_view_quiz_history}
        onChange={(e) =>
          setNewRolePermissions(p => ({
            ...p,
            can_view_quiz_history: e.target.checked,
          }))
        }
      />
    }
    label="View"
  />
</Paper>

{/* Custom */}
<Paper sx={permissionCardSx}>
  <Typography sx={permissionTitleSx}>Custom</Typography>
  <FormControlLabel
    sx={{ ml: 0 }}
    control={
      <input
        type="checkbox"
        checked={newRolePermissions.can_register_custom}
        onChange={(e) =>
          setNewRolePermissions(p => ({
            ...p,
            can_register_custom: e.target.checked,
          }))
        }
      />
    }
    label="Register"
  />
</Paper>

{/* All Custom Roles */}
<Paper sx={permissionCardSx}>
  <Typography sx={permissionTitleSx}>All Custom Roles</Typography>
  <FormControlLabel
    sx={{ ml: 0 }}
    control={
      <input
        type="checkbox"
        checked={newRolePermissions.can_view_all_custom_roles}
        onChange={(e) =>
          setNewRolePermissions(p => ({
            ...p,
            can_view_all_custom_roles: e.target.checked,
          }))
        }
      />
    }
    label="View"
  />
</Paper>

{/* Custom Role Permission */}
<Paper sx={permissionCardSx}>
  <Typography sx={permissionTitleSx}>Custom Role Permission</Typography>

  <FormControlLabel
    sx={{ ml: 0 }}
    control={
      <input
        type="checkbox"
        checked={newRolePermissions.can_set_custom_role_permission}
        onChange={(e) =>
          setNewRolePermissions(p => ({
            ...p,
            can_set_custom_role_permission: e.target.checked,
          }))
        }
      />
    }
    label="Set"
  />

  <FormControlLabel
    sx={{ ml: 0 }}
    control={
      <input
        type="checkbox"
        checked={newRolePermissions.can_view_custom_role_permission}
        onChange={(e) =>
          setNewRolePermissions(p => ({
            ...p,
            can_view_custom_role_permission: e.target.checked,
          }))
        }
      />
    }
    label="View"
  />
</Paper>

{/* User Role */}
<Paper sx={permissionCardSx}>
  <Typography sx={permissionTitleSx}>User Role</Typography>
  <FormControlLabel
    sx={{ ml: 0 }}
    control={
      <input
        type="checkbox"
        checked={newRolePermissions.can_change_user_role}
        onChange={(e) =>
          setNewRolePermissions(p => ({
            ...p,
            can_change_user_role: e.target.checked,
          }))
        }
      />
    }
    label="Change"
  />
</Paper>

{/* Users Of Custom Roles */}
<Paper sx={permissionCardSx}>
  <Typography sx={permissionTitleSx}>Users Of Custom Roles</Typography>
  <FormControlLabel
    sx={{ ml: 0 }}
    control={
      <input
        type="checkbox"
        checked={newRolePermissions.can_view_users_of_custom_roles}
        onChange={(e) =>
          setNewRolePermissions(p => ({
            ...p,
            can_view_users_of_custom_roles: e.target.checked,
          }))
        }
      />
    }
    label="View"
  />
</Paper>

{/* User Details */}
<Paper sx={permissionCardSx}>
  <Typography sx={permissionTitleSx}>User Details</Typography>
  <FormControlLabel
    sx={{ ml: 0 }}
    control={
      <input
        type="checkbox"
        checked={newRolePermissions.can_view_student_list}
        onChange={(e) =>
          setNewRolePermissions(p => ({
            ...p,
            can_view_student_list: e.target.checked,
          }))
        }
      />
    }
    label="View"
  />
</Paper>

{/* Password */}
<Paper sx={permissionCardSx}>
  <Typography sx={permissionTitleSx}>Password</Typography>
  <FormControlLabel
    sx={{ ml: 0 }}
    control={
      <input
        type="checkbox"
        checked={newRolePermissions.can_reset_password}
        onChange={(e) =>
          setNewRolePermissions(p => ({
            ...p,
            can_reset_password: e.target.checked,
          }))
        }
      />
    }
    label="Reset"
  />
</Paper>

{/* Registration */}
<Paper sx={permissionCardSx}>
  <Typography sx={permissionTitleSx}>Registration</Typography>
  <FormControlLabel
    sx={{ ml: 0 }}
    control={
      <input
        type="checkbox"
        checked={newRolePermissions.can_bulk_registration}
        onChange={(e) =>
          setNewRolePermissions(p => ({
            ...p,
            can_bulk_registration: e.target.checked,
          }))
        }
      />
    }
    label="Bulk"
  />
</Paper>

{/* Disable Users */}
<Paper sx={{ ...permissionCardSx, mb: 3 }}>
  <Typography sx={permissionTitleSx}>Disable Users</Typography>
  <FormControlLabel
    sx={{ ml: 0 }}
    control={
      <input
        type="checkbox"
        checked={newRolePermissions.can_enable_disable_users}
        onChange={(e) =>
          setNewRolePermissions(p => ({
            ...p,
            can_enable_disable_users: e.target.checked,
          }))
        }
      />
    }
    label="Enable"
  />
</Paper>


                    </Box>

                    {/* Sticky Footer */}
                    <Box
                        sx={{
                            position: "sticky",
                            bottom: 0,
                            zIndex: 2,
                            background: mode === "dark"
                                ? "linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)"
                                : mode === "custom"
                                    ? `linear-gradient(135deg, ${customColors?.background || "#f5f5f5"} 0%, ${customColors?.primary || "#1e8bafff"}15 100%)`
                                    : "linear-gradient(135deg, #ffffff 0%, #f0f7ff 100%)",
                            p: 2,
                            borderRadius: "0 0 20px 20px",
                            boxShadow: mode === "dark"
                                ? "0 -4px 12px rgba(0, 0, 0, 0.3)"
                                : "0 -4px 12px rgba(30, 139, 175, 0.1)",
                            borderTop: mode === "dark" ? "1px solid rgba(255, 255, 255, 0.1)" : "1px solid rgba(30, 139, 175, 0.1)",
                        }}
                    >
                        <Button
                            variant="contained"
                            onClick={handlePermissionDialogSave}
                            sx={{
                                float: "right",
                                background: "linear-gradient(135deg, #1e3a8a 0%, #1e8bafff 100%)",
                                color: "white",
                                fontWeight: 600,
                                fontSize: "0.95rem",
                                textTransform: "none",
                                px: 3,
                                py: 1.25,
                                borderRadius: "12px",
                                boxShadow: "0 4px 14px rgba(30, 139, 175, 0.3)",
                                transition: "all 0.3s ease",
                                "&:hover": {
                                    background: "linear-gradient(135deg, #1e3a8a 0%, #1a7a9a 100%)",
                                    boxShadow: "0 6px 20px rgba(30, 139, 175, 0.4)",
                                    transform: "translateY(-2px)",
                                },
                                "&:active": {
                                    transform: "translateY(0px)",
                                    boxShadow: "0 2px 8px rgba(30, 139, 175, 0.3)",
                                },
                            }}
                        >
                            Save Permissions
                        </Button>
                    </Box>
                </Box>
            </Modal>
        </>
    );
}